export default "__VITE_ASSET__CY$edd5E__"